export default {
  "content": "<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#000\" fill-opacity=\".05\"/><path d=\"M27 13H13c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-8c0-1.66-1.34-3-3-3zm1 11c0 .55-.45 1-1 1H13c-.55 0-1-.45-1-1v-5h16v5zm-16-7v-1c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v1H12z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};